const KEY_PREFIX = 'ddv:aiChat:connection:';

export const CHAT_AI_CONNECTION_CHANGED = 'ddv-ai-chat-connection-changed';

/**
 * @returns {{
 *   agent: string,
 *   visibility: string,
 *   sqlEndpointUrl: string,
 *   lakehouseName: string,
 *   customInstructions: string,
 *   introMessage: string,
 * }}
 * `agent` — when using REST, the chatbot agent id from GET /chatbot/agents (UUID string).
 * `visibility` — comma-separated API tokens (e.g. `admin,internal`) when stored locally.
 * `introMessage` — optional Markdown welcome template (`{{userFirstName}}`, `{{agentName}}`).
 */
export function getDefaultConnectionSettings() {
  return {
    agent: '',
    visibility: 'admin',
    sqlEndpointUrl: '',
    lakehouseName: '',
    customInstructions: '',
    introMessage: '',
  };
}

/**
 * @param {string | null | undefined} projectId
 */
export function getConnectionSettings(projectId) {
  if (!projectId) {
    return getDefaultConnectionSettings();
  }
  try {
    const raw = window.localStorage.getItem(`${KEY_PREFIX}${projectId}`);
    if (!raw) {
      return getDefaultConnectionSettings();
    }
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') {
      return getDefaultConnectionSettings();
    }
    return { ...getDefaultConnectionSettings(), ...parsed };
  } catch {
    return getDefaultConnectionSettings();
  }
}

/**
 * @param {string} projectId
 * @param {Partial<ReturnType<typeof getDefaultConnectionSettings>>} data
 */
export function setConnectionSettings(projectId, data) {
  if (!projectId) {
    return;
  }
  const next = { ...getConnectionSettings(projectId), ...data };
  window.localStorage.setItem(
    `${KEY_PREFIX}${projectId}`,
    JSON.stringify(next),
  );
  window.dispatchEvent(
    new CustomEvent(CHAT_AI_CONNECTION_CHANGED, { detail: { projectId } }),
  );
}
